import { render, staticRenderFns } from "./Aragon.vue?vue&type=template&id=532ce080&"
import script from "./Aragon.vue?vue&type=script&lang=js&"
export * from "./Aragon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports